import { Box, Typography } from '@mui/material';
import { formatMoney, formatNumber, formatPercent } from '../../utils/format';
import TruncatedText from '../common/TruncatedText';
import StatusBadge from '../status/StatusBadge';

export const NAME_WIDTH = 280;

// Name with a muted second line (id, parent), at a fixed width; cut text shows in full on hover
export function NameCell({ name, secondary, width = NAME_WIDTH }) {
  return (
    <Box sx={{ width, minWidth: width, maxWidth: width }}>
      <TruncatedText variant="body2" sx={{ fontWeight: 500 }}>{name || '—'}</TruncatedText>
      {secondary && (
        <TruncatedText variant="caption" color="text.secondary" component="div">{secondary}</TruncatedText>
      )}
    </Box>
  );
}

// effective_status as labelled and coloured by the API, e.g. CAMPAIGN_PAUSED -> purple "Campaign paused"
export function StatusChip({ row }) {
  if (!row.effective_status_label) return '—';
  return <StatusBadge tone={row.effective_status_tone} label={row.effective_status_label} />;
}

export function Budget({ row }) {
  if (row.daily_budget) return <>{formatMoney(row.daily_budget, row.currency)}<Muted> / day</Muted></>;
  if (row.lifetime_budget) return <>{formatMoney(row.lifetime_budget, row.currency)}<Muted> lifetime</Muted></>;
  return <Muted>—</Muted>;
}

export function Mono({ children }) {
  if (!children) return '—';
  return (
    <Box component="span" sx={{ fontFamily: 'monospace', fontSize: 13, bgcolor: 'grey.100', px: 0.75, py: 0.25,
      borderRadius: 1 }}>
      {children}
    </Box>
  );
}

function Muted({ children }) {
  return <Typography component="span" variant="body2" color="text.secondary">{children}</Typography>;
}

// Insight totals for the selected range, shared by every list
export const METRIC_COLUMNS = [
  { id: 'spend', label: 'Spend', align: 'right', render: (row) => formatMoney(row.spend, row.currency) },
  { id: 'impressions', label: 'Impressions', align: 'right', render: (row) => formatNumber(row.impressions) },
  { id: 'clicks', label: 'Clicks', align: 'right', render: (row) => formatNumber(row.clicks) },
  { id: 'link_clicks', label: 'Link clicks', align: 'right', render: (row) => formatNumber(row.link_clicks) },
  { id: 'ctr', label: 'CTR', align: 'right', sort: false, render: (row) => formatPercent(row.ctr) },
  { id: 'cpc', label: 'CPC', align: 'right', sort: false, render: (row) => formatMoney(row.cpc, row.currency) },
];
